import React from 'react';
import moment from 'moment';
import DownloadIcon from '~/components/downloadIcon/downloadIcon';
import UserFullname from '~/components/userFullname/userFullname';

const ReportTable = ({ reports, onDownload }) => (
  <div>
    <header className="flex ttu table-header pv2">
      <div className="w-50 pl3 pr2">Lots</div>
      <div className="w-20 pr2">Generated on</div>
      <div className="w-20 pr2">Generated by</div>
      <div className="w-10 pr3" />
    </header>
    <div>
      {reports.map(report => (
        <div className="flex pointer pv3 bt-divider row-hover items-center" key={report.id}>
          <div className="w-50 pl3 pr2">
            <strong>{report.lots.map(l => l.reference).join(', ')}</strong>
          </div>
          <div className="w-20 pr2">
            <strong>{moment(report.createdAt).format('dddd Do MMMM')}</strong>
          </div>
          <div className="w-20 pr2">
            <strong>{report.autogenerated ? 'Autogenerated' : <UserFullname user={report.createdByUser} />}</strong>
          </div>
          <div className="w-10 pr3 tc">
            <DownloadIcon onClick={() => onDownload(report.id)} />
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default ReportTable;



// WEBPACK FOOTER //
// ./src/components/reportTable/reportTable.jsx